import { useState, useEffect, useCallback } from 'react';
import { defaultSelezione } from '../lib/venduto';

const KEY = 'venduto_periodo';

/** Selezione di periodo condivisa fra le pagine del Controllo di Gestione. */
export function useVendutoPeriodo(archivio) {
  const [sel, setSel] = useState(null);

  useEffect(() => {
    if (sel || !archivio) return;
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved?.granularita) {
        setSel(saved);
        return;
      }
    } catch (e) {
      /* selezione salvata non leggibile: uso il default */
    }
    setSel(defaultSelezione(archivio));
  }, [archivio, sel]);

  const update = useCallback((v) => {
    setSel(v);
    try {
      localStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) {
      /* storage pieno: non bloccante */
    }
  }, []);

  return [sel, update];
}

export default useVendutoPeriodo;
